module.exports = __webpack_public_path__ + "img/about-us-incorporation.88b94ff6.png";